import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "spinner-container" }
const _hoisted_2 = ["value"]

import { nextTick, Ref, ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'NumberSpinner',
  props: {
    modelValue: {},
    step: {},
    decimalPrecision: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const field = ref(null) as Ref<null | HTMLInputElement>

/// /

function stepValue (multiplier: number): void {
  updateValue(props.modelValue + (props.step ?? 1) * multiplier)
}

function onKeyDown (ev: KeyboardEvent): void {
  if (field.value == null) return

  if (ev.key.startsWith('Arrow')) {
    ev.stopPropagation()

    const selStart = Math.max(field.value.selectionStart ?? 1, 1)
    const v = field.value.value
    const periodPos = (props.decimalPrecision === 0) ? v.length : v.indexOf('.')

    let step: number
    if (selStart <= periodPos) {
      // 12^3.4567 (selStart 2, periodPos 3)
      // 45^6 (selStart 2, periodPos 3)
      step = Math.pow(10, periodPos - selStart)
    } else {
      // 12.34^567 (selStart 5, periodPos 2)
      step = Math.pow(10, periodPos - selStart + 1)
    }
    if (ev.key === 'ArrowUp') {
      const prevSign = (props.modelValue >= 0)
      updateValue(props.modelValue + step)
      ev.preventDefault()
      void nextTick(() => {
        const nextSign = (props.modelValue >= 0)
        const cursor = (prevSign !== nextSign) ? selStart - 1 : selStart
        field.value!.setSelectionRange(cursor, cursor)
      })
    } else if (ev.key === 'ArrowDown') {
      const prevSign = (props.modelValue >= 0)
      updateValue(props.modelValue - step)
      ev.preventDefault()
      void nextTick(() => {
        const nextSign = (props.modelValue >= 0)
        const cursor = (prevSign !== nextSign) ? selStart + 1 : selStart
        field.value!.setSelectionRange(cursor, cursor)
      })
    }
  }
}

function updateValue (newValue: string | number): void {
  const step = props.step ?? 1
  newValue = (Math.floor(Number(newValue) / step + 0.5) | 0) * step
  emit('update:modelValue', newValue)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (stepValue(-1)))
    }, "<<"),
    _createElementVNode("input", {
      ref_key: "field",
      ref: field,
      value: _ctx.modelValue.toFixed(_ctx.decimalPrecision || 1),
      onKeydown: onKeyDown,
      onChange: _cache[1] || (_cache[1] = e => updateValue((e.target as any).value))
    }, null, 40, _hoisted_2),
    _createElementVNode("button", {
      onClick: _cache[2] || (_cache[2] = ($event: any) => (stepValue(1)))
    }, ">>")
  ]))
}
}

})